import { ComposedChart, Bar, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import type { Request, TabState } from '../../types';
import { buildTrendData } from '../../utils/trend';
interface Props {
  region: string;
  sub: string[];
  status: string;
  requests: Request[];
  /** Quarter mode, FY/Q selection and date range drive the buckets (ADR 0010). */
  state: Pick<TabState, 'fy' | 'q' | 'qMode' | 'dateFrom' | 'dateTo'>;
}
export function TrendChart({
  region,
  sub,
  status,
  requests,
  state
}: Props) {
  const data = buildTrendData(requests, {
    region,
    sub,
    status,
    state
  });
  return <div className="mx-[18px] mb-3 bg-white border border-[#e8eaf0] rounded-[10px] p-[14px_16px] shadow-[0_1px_3px_rgba(0,0,0,0.04)]" data-id="element-113" data-mp="2topbj0uxjjpx">
      <div className="flex gap-[14px] mb-[10px] text-[10px] text-[#667085]" data-id="element-114" data-mp="2xmwum2cv8x4a">
        <span className="flex items-center gap-1" data-id="element-115" data-mp="2jpqbu7s56yf2">
          <span className="w-[10px] h-[10px] rounded-[3px] inline-block" style={{
          background: '#b8cce8'
        }} data-id="element-116" data-mp="2oo1jqcyvmyun" />
          Requests
        </span>
        <span className="flex items-center gap-1" data-id="element-117" data-mp="2p262lny64803">
          <span className="w-[10px] h-[10px] rounded-[3px] inline-block" style={{
          background: '#d4a017'
        }} data-id="element-118" data-mp="2k4wfwg25yafy" />
          GNARR ($M)
        </span>
      </div>
      <ResponsiveContainer width="100%" height={190} data-id="element-119" data-mp="2y3mfc2cggm7h">
        <ComposedChart data={data} margin={{
        top: 4,
        right: 8,
        bottom: 0,
        left: 0
      }} data-id="element-120" data-mp="2t4t2mc4zsz8d">
          <CartesianGrid stroke="rgba(0,0,0,0.05)" vertical={false} data-id="element-121" data-mp="25fgs98xxil4h" />
          <XAxis dataKey="quarter" tick={{
          fontSize: 9,
          fill: '#8892a0'
        }} axisLine={false} tickLine={false} data-id="element-122" data-mp="25dnn5y2ys8yl" />
          <YAxis yAxisId="left" tick={{
          fontSize: 9,
          fill: '#8892a0'
        }} axisLine={false} tickLine={false} data-id="element-123" data-mp="21cbutksph9mp" />
          <YAxis yAxisId="right" orientation="right" tick={{
          fontSize: 9,
          fill: '#8892a0'
        }} axisLine={false} tickLine={false} data-id="element-124" data-mp="2aetg9x0jdy8n" />
          <Tooltip contentStyle={{
          fontSize: 11,
          border: '1px solid #e8eaf0',
          borderRadius: 6
        }} formatter={(v: number, name: string) => [name === 'gnarr' ? '$' + v + 'M' : v, name === 'gnarr' ? 'GNARR ($M)' : 'Requests']} data-id="element-125" data-mp="1mogxts7o0j3t" />
          <Legend wrapperStyle={{
          display: 'none'
        }} data-id="element-126" data-mp="3mqghfr5n8cgj" />
          <Bar yAxisId="left" dataKey="requests" fill="#b8cce8" radius={[3, 3, 0, 0]} name="requests" data-id="element-127" data-mp="3mp5etunxpar0" />
          <Line yAxisId="right" type="monotone" dataKey="gnarr" stroke="#d4a017" strokeWidth={2.5} dot={{
          fill: '#d4a017',
          r: 4
        }} activeDot={{
          r: 5
        }} name="gnarr" data-id="element-128" data-mp="bxfitxuupqy" />
        </ComposedChart>
      </ResponsiveContainer>
    </div>;
}